const config = require("../config")

module.exports = {
    login: {
        url: config.base_dev_site_url + "user/login",
        type: "post",
    },
    fetchWoldMap: {
        url: config.base_foster_url + "world-map/list?key=" + config.mini_key,
        type: "get",
    },
    fetchGardenList: {
        url: config.base_foster_url + "garden/list/{current}/{size}?key=" + config.mini_key,
        type: "get",
    },
}